import type {
  AssemblyDocumentNode,
  ModelAssetNode,
} from '@puppycad/cad-core';

/**
 * 读取与工作文档子节点匹配的项目模型直接子节点。
 *
 * 设计说明：
 * 1. working `_assembly.json` 中的 `nodeKey` 是装配结构的稳定身份；
 * 2. 后端节点快照中的 instanceUuid 可能随版本切换变化，不能优先作为本地结构匹配依据；
 * 3. instanceId 只作为旧数据或缺失 nodeKey 时的兜底，避免同仓库多实例时误配。
 *
 * @param root 当前项目模型根节点。
 * @param workingNode 工作装配文档中的直接子节点。
 * @returns 命中的模型树节点；root 尚未同步时返回 null。
 */
export function resolveProjectModelDirectChildForWorkingNode(
  root: ModelAssetNode,
  workingNode: AssemblyDocumentNode,
): ModelAssetNode | null {
  const byNodeKey = root.children.find((child) => child.nodeKey === workingNode.nodeKey);
  if (byNodeKey) {
    return byNodeKey;
  }

  const instanceId = workingNode.instanceId?.trim() ?? '';
  if (instanceId) {
    return root.children.find((child) => child.instanceUuid?.trim() === instanceId) ?? null;
  }

  return null;
}
